import en from "./en";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...en,
};
